import { BaseService } from "./../base";
export class CommuneService extends BaseService {
  static get entity() {
    return "commune";
  }
  static get name() {
    return "commune";
  }

  static async getAll() {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/all`, this.name);
  }

  static async getByProvinceId(id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find/${id}`, this.name);
  }
  static async getByRegionId(id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_region_id/${id}`, this.name);
  }
}
